import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@/.sourceflow/skills_for_featured_job_offers.json";

export const useCandidateSkills = ({ limit } = {}) => {
  const collection = useSourceFlowCollection(data);

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useCandidateSkills;
